module.exports = __webpack_public_path__ + "static/media/_basque-country.9bd5abb3.png";